export const USERDETAILS = "USERDETAILS";
export const ADMINDETAILS = "ADMINDETAILS"